var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"maintenance-page",style:({
    background: `${
      _vm.getCurrentBackgroundImageMaintenance
        ? `url(${_vm.getCurrentBackgroundImageMaintenance.url}) no-repeat center center fixed`
        : null
    }`,
  })},[_c('div',{staticClass:"maintenance-content"},[_c('img',{attrs:{"src":require("@/assets/images/logo-color.png"),"alt":"","height":"70"}}),_c('i',{staticClass:"fa fa-gear"}),_c('p',{staticClass:"maintenance-text p-3"},[_vm._v(" "+_vm._s(_vm.maintenanceInfo.title ? _vm.maintenanceInfo.title : "Modo mantenimiento activado")+" ")]),_c('p',{staticClass:"maintenance-contact p-3"},[_vm._v(" "+_vm._s(_vm.maintenanceInfo.description ? _vm.maintenanceInfo.description : "Cualquier comentario o duda: desarrollo@fluxsolar.cl")+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }